function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
// Customizable Area End

export const configJSON = require("./config");
export default class RolesPermissions2Controller extends BlockComponent {
  // Customizable Area Start
  // Customizable Area End

  constructor(props) {
    super(props);
    _defineProperty(this, "txtInputWebProps", {
      onChangeText: text => {
        this.setState({
          txtInputValue: text
        });
      },
      secureTextEntry: false
    });
    _defineProperty(this, "txtInputMobileProps", _objectSpread(_objectSpread({}, this.txtInputWebProps), {}, {
      autoCompleteType: "email",
      keyboardType: "email-address"
    }));
    _defineProperty(this, "txtInputProps", this.isPlatformWeb() ? this.txtInputWebProps : this.txtInputMobileProps);
    _defineProperty(this, "btnShowHideProps", {
      onPress: () => {
        this.setState({
          enableField: !this.state.enableField
        });
        this.txtInputProps.secureTextEntry = !this.state.enableField;
        this.btnShowHideImageProps.source = this.txtInputProps.secureTextEntry ? imgPasswordVisible : imgPasswordInVisible;
      }
    });
    _defineProperty(this, "btnShowHideImageProps", {
      source: this.txtInputProps.secureTextEntry ? imgPasswordVisible : imgPasswordInVisible
    });
    _defineProperty(this, "btnExampleProps", {
      onPress: () => this.doButtonPressed()
    });
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [getName(MessageEnum.AccoutLoginSuccess)
    // Customizable Area Start
    // Customizable Area End
    ];
    this.state = {
      txtInputValue: "",
      txtSavedValue: "A",
      enableField: false
      // Customizable Area Start
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }
  async receive(from, message) {
    runEngine.debugLog("Message Recived", message);
    if (message.id === getName(MessageEnum.AccoutLoginSuccess)) {
      let value = message.getData(getName(MessageEnum.AuthTokenDataMessage));
      this.showAlert("Change Value", "From: " + this.state.txtSavedValue + " To: " + value);
      this.setState({
        txtSavedValue: value
      });
    }

    // Customizable Area Start
    // Customizable Area End
  }
  doButtonPressed() {
    let msg = new Message(getName(MessageEnum.AccoutLoginSuccess));
    msg.addData(getName(MessageEnum.AuthTokenDataMessage), this.state.txtInputValue);
    this.send(msg);
  }

  // Customizable Area Start
  // Customizable Area End
}